<template>
  <vs-popup class="change-customer-currency-popup" id="popup" title="CHANGE CUSTOMER CURRENCY" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <div v-if="errors.length">
        <vs-alert color="danger" class="h-auto">
          Customer currency cannot be changed because of the following issues:
        </vs-alert>

        <ul class="blocked-errors">
          <li v-for="(error, index) in errors" :key="index">
            {{ error }}
          </li>
        </ul>

        <div class="flex justify-end mt-6">
          <vs-button color="warning" @click="open = false">
            Close
          </vs-button>
        </div>
      </div>

      <template v-else>
        <div class="currency-preview mb-6">
          <div class="currency-box from">
            <small class="label">Current Currency</small>
            <div class="currency-value">
              {{ currency || '-' }}
            </div>
          </div>

          <div class="currency-arrow">
            <i class="feather icon-arrow-right"></i>
          </div>

          <div class="currency-box to">
            <small class="label">New Currency</small>
            <v-select label="name" :reduce="function (option) { return option.value }" :clearable="false"
              v-model="form.account_currency" :options="formatted_currency" :dir="$vs.rtl ? 'rtl' : 'ltr'">
              <template slot="option" slot-scope="option">
                <span>
                  {{ option.name }} - {{ option.value }}
                </span>
              </template>
            </v-select>
          </div>
        </div>

        <div class="flex justify-end mt-12">
          <vs-button @click.stop="onClickSubmit" :disabled="!form.account_currency" color="primary" type="filled" button="submit">
            Save & Close
          </vs-button>
        </div>
      </template>

    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CustomerRepository = RepositoryFactory.get('customer')

import { mapActions, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    customer_id: null,
    currency: '',
    form: {
      account_currency: ''
    },
    errors: []
  }
}

export default {
  name: 'UpdateCustomerCurrencyPopUp',

  data() {
    return initialState()
  },

  computed: {
    ...mapGetters(['currencies']),

    formatted_currency() {
      return this.currencies.filter(
        c => c.value !== this.currency
      )
    }
  },

  methods: {
    ...mapActions(['fetchCurrencyList']),

    async openPopup(customer_id, currency) {
      try {
        Object.assign(this.$data, initialState())

        this.customer_id = customer_id
        this.currency = currency

        await this.checkCurrencyChange()
        await this.fetchCurrencyList()

        this.open = true
      } catch (error) {
        console.error(error)
      }
    },

    async checkCurrencyChange() {
      try {
        await CustomerRepository.checkCurrencyChangePosibility(this.customer_id)

        this.errors = []
      } catch (error) {
        this.errors = []

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.data &&
          error.response.data.data.errors &&
          error.response.data.data.errors.issues
        ) {
          this.errors = error.response.data.data.errors.issues
        } else {
          this.errors.push(
            'Unable to validate currency change.'
          )
        }
      }
    },

    async onClickSubmit() {
      this.$vs.loading()

      try {
        await CustomerRepository.updateCustomerCurrency(
          this.customer_id,
          this.form
        )

        this.$emit('refreshData')
        this.open = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }

      this.$vs.loading.close()
    }
  },

  components: {
    'v-select': vSelect
  },

  mixins: [SuccessMessage, ErrorMessages]
}
</script>

<style scoped>
.change-customer-currency-popup>>>.vs-popup {
  min-width: 30% !important;
}

.currency-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 25px;
}

.currency-box {
  flex: 1;
  text-align: center;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid #e5e5e5;
}

.currency-box.from {
  border-left: 4px solid #7367f0;
}

.currency-box.to {
  border-left: 4px solid #28c76f;
}

.currency-value {
  font-size: 22px;
  font-weight: 700;
  margin-top: 6px;
}

.currency-arrow {
  font-size: 24px;
  color: #7367f0;
}

.label {
  display: block;
  color: #6c757d;
  margin-bottom: 5px;
  font-size: 12px;
  text-transform: uppercase;
}

.blocked-header {
  padding: 12px;
  border-radius: 6px;
  background: #fff5f5;
  border: 1px solid #ea5455;
  color: #ea5455;
  font-weight: 600;
}

.blocked-errors {
  margin-top: 15px;
  padding-left: 20px;
}

.blocked-errors li {
  margin-bottom: 8px;
  color: #ea5455;
}

@media (max-width: 768px) {
  .currency-preview {
    flex-direction: column;
  }

  .currency-arrow {
    transform: rotate(90deg);
  }
}

.currency-box.to {
  min-height: 110px;
}

.currency-box.to .v-select {
  margin-top: 10px;
  text-align: left;
}

.currency-box.to .vs__dropdown-toggle {
  min-height: 42px;
}
</style>